import React__default, { useState } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { ACTIONS_LIST, INSURANCE_DEFAULT_TABS_ORDER } from '@sravni/ugc/lib/specialOffers/lists';
import { SpecialOffers } from '../../SpecialOffers/src/SpecialOffers.js';

const SpecialOffersForInsurance = ({ maxDesktopVisibleItems = undefined, ...props }) => {
    const isMobile = useIsMobile();
    const [activeTab, setActiveTab] = useState();
    const [tabs, setTabs] = useState(ACTIONS_LIST);
    const [actionsHeight, setActionsHeight] = useState('0px');
    const handleSetActionsItemsCount = (count) => {
        if (tabs === ACTIONS_LIST) {
            if (!(count && ((isMobile && count > 0) || (!isMobile && count > 2)))) {
                setActiveTab(INSURANCE_DEFAULT_TABS_ORDER[0]);
                setTabs([...INSURANCE_DEFAULT_TABS_ORDER]);
            }
            setActionsHeight('auto');
        }
    };
    return (React__default.createElement("div", { style: { height: actionsHeight, overflow: 'hidden' } },
        React__default.createElement(SpecialOffers, { ...props, tabs: tabs, activeTab: activeTab, setItemsCount: handleSetActionsItemsCount, maxDesktopVisibleItems: tabs === ACTIONS_LIST ? 4 : maxDesktopVisibleItems })));
};

export { SpecialOffersForInsurance };
//# sourceMappingURL=SpecialOffersForInsurance.js.map
